import { useState, useEffect } from "react"
import { Button, InputGroup, Label, TextField } from "@heroui/react"
import { cn } from "@heroui/react"
import type { CountryCode } from "@/data/country-codes"
import { CountryCodeSelect } from "./country-code-select"

interface PhoneInputProps {
    value?: string
    onChange?: (value: string) => void
    onGetCode?: () => Promise<void>
    codeValue?: string
    onCodeChange?: (value: string) => void
    countryCode?: string
    onCountryCodeChange?: (code: string) => void
    countries?: CountryCode[]
    className?: string
    disabled?: boolean
}

export function PhoneInput({
    value = "",
    onChange,
    onGetCode,
    codeValue = "",
    onCodeChange,
    countryCode = "86",
    onCountryCodeChange,
    countries,
    className,
    disabled = false,
}: PhoneInputProps) {
    const [countdown, setCountdown] = useState(0)

    useEffect(() => {
        if (countdown > 0) {
            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer)
                        return 0
                    }
                    return prev - 1
                })
            }, 1000)
            return () => clearInterval(timer)
        }
    }, [countdown])

    const handleGetCode = () => {
        if (onGetCode) {
            onGetCode()
                .then(() => {
                    setCountdown(60);
                })
                .catch(() => {
                    // 验证码发送失败，不触发倒计时
                });
        }
    }

    return (
        <div className={cn("space-y-4", className)}>
            <TextField
                fullWidth
                isDisabled={disabled}
                value={value}
                onChange={(next) => onChange?.(next)}
            >
                <Label>手机号码</Label>
                <InputGroup fullWidth>
                    <InputGroup.Prefix className="ps-0">
                        <CountryCodeSelect
                            countries={countries}
                            value={countryCode}
                            onChange={onCountryCodeChange}
                            disabled={disabled}
                        />
                    </InputGroup.Prefix>
                    <InputGroup.Input type="tel" placeholder="请输入手机号" />
                </InputGroup>
            </TextField>
            <TextField
                fullWidth
                isDisabled={disabled}
                value={codeValue}
                onChange={(next) => onCodeChange?.(next)}
            >
                <Label>验证码</Label>
                <InputGroup fullWidth>
                    <InputGroup.Input placeholder="请输入验证码" />
                    <InputGroup.Suffix className="pe-0">
                        <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            onPress={handleGetCode}
                            isDisabled={countdown > 0 || disabled}
                        >
                            {countdown > 0 ? `${countdown}s` : "获取验证码"}
                        </Button>
                    </InputGroup.Suffix>
                </InputGroup>
            </TextField>
        </div>
    )
}
